import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { HorizonTypesProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllHorizonTypesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "HorizonTypes" } }) {
    nodes {
      data
    }
  }
}
`;

export const HorizonTypesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
